/**
 * SDK/Frontend用ロガーユーティリティ
 *
 * import.meta.env.VITE_ENVIRONMENTに基づいてログ出力を制御します。
 * 本番環境ではconsole.errorのみ出力されます。
 */
import { createLogger as createBaseLogger } from '@darkchat/shared';
// VITE_ENVIRONMENTをチェックしてロガーを作成
const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';
export const logger = createBaseLogger(isProduction);
